import React from 'react'
import PropTypes from 'prop-types'
import XmarkIcon from '../../ui/icons/XmarkIcon'
import {
  MODAL_HEADER_CLASS, MODAL_TITLE_CLASS, MODAL_CLOSE_BTN_CLASS
} from './styles'

const ModalHeader = ({ title, onClose, titleClassName = MODAL_TITLE_CLASS }) => (
  <div className={MODAL_HEADER_CLASS}>
    <h5 className={titleClassName}>{title}</h5>
    <button
      aria-label="Fermer la modale"
      className={MODAL_CLOSE_BTN_CLASS}
      type="button"
      onClick={onClose}
    >
      <XmarkIcon className="tw:w-5 tw:h-5" />
    </button>
  </div>
)

ModalHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  titleClassName: PropTypes.string
}

ModalHeader.defaultProps = {
  titleClassName: MODAL_TITLE_CLASS
}

export default ModalHeader
